import { ISuperTableCalculationFunction } from '@modeso/types__aumico-lib-annualreport-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { SuperTableColumnBelongingYear } from '@modeso/types__aumico-lib-notes-be/dist/models/enums/super_table_column_belonging_year.enum';
import { ISuperTableItemSelection } from './super-table-item-selection.interface';
import { SuperTableColumnWidth } from '../enums/SuperTableColumnWidth.ebum';

export interface ISuperTableAddCalculationResult {
    title: string;
    function: ISuperTableCalculationFunction;
    rowSelections: ISuperTableItemSelection[];
    columnSelections?: INameId[];
    relationItem?: ISuperTableItemSelection;
    belongingYear?: SuperTableColumnBelongingYear;
    columnWidth?: SuperTableColumnWidth;
}
